(function presscenter() {
    // cache
    var fulltextsearch = document.querySelector('input[name="fulltextsearch"]');
    var datefrom = document.querySelector('input[name="datefrom"]');
    var dateto = document.querySelector('input[name="dateto"]');
    var resultarea = document.getElementById("resultarea");
    var commandArea = document.getElementById("commandarea");
    var loadmoreCommand = document.getElementById("loadmore-command");
    var loadallCommand = document.getElementById("loadall-command");

    // preload
    var viewTypes = {
        "liste": 0,
        "kacheln": 1
    };
    var numberResultsToReturn = [18, 9];                            // index corresponds to value in viewTypes
    var hash = decodeURIComponent(location.hash).split("/");
    var viewType = hash.length === 2 && hash[1] === "liste" ? viewTypes.liste : viewTypes.kacheln;
    resultarea.setAttribute("data-view", "" + viewType);
    document.querySelector(".js-command.active")?.classList.remove("active");
    document.querySelector('.js-command[data-command="' + (hash.length === 2 ? hash[1] : "kacheln") + '"]').classList.add("active");

    // memory
    var forceAmount = false;
    var old = {
        category: null,
        fulltext: null,
        dateafter: null,
        datebefore: null,
        viewType: viewType
    };
    var maxNumberItems;
    var currentNumberItems;
    var fetchmorestringbase;
    var maxFetchmoreItems = 0;
    var categories = {};                // id to name
    var reverseCategories = {};         // slug to id
    document.querySelectorAll(".presscenter .filterrow .dropdown-item[data-id]").forEach((ddi) => {
        categories[ddi.dataset.id] = ddi.innerText;
        reverseCategories[ddi.getAttribute("href").substring(1)] = ddi.dataset.id;      // .href contains path
    });

    // templating
    jQuery.views.helpers({
        date: function(ISODate) {
            return new Date(ISODate).toLocaleDateString("de-DE", {day:"2-digit", month: "long", year: "numeric"});
        },
        cat: function(category_ids) {
            return category_ids.length ? categories["" + category_ids[0]] : "";
        },
        time: function(text) {
            // https://thereadtime.com/ :  238 words / minute
            // https://www.inter-contact.de/en/blog/text-length-languages :  6.752 letters per word in German
            // see single-pressrelease.php
            return Math.ceil((text.length / 6.752) / 238);
        }
    });
    var template = jQuery.templates("#pressrelease-preview-template");
    
    // code
    var currentScope;
    function updateResults() {
        var category = decodeURIComponent(location.hash).split("/")[0].substring(1);
        var fulltext = fulltextsearch.value;
        var dateafter = datefrom.value;
        var datebefore = dateto.value;
        if(category !== old.category || fulltext !== old.fulltext || dateafter !== old.dateafter || datebefore !== old.datebefore) {
            old.category = category;
            old.fulltext = fulltext;
            old.dateafter = dateafter;
            old.datebefore = datebefore;
            commandArea.style.display = "none";
            currentNumberItems = 0;
            var fetchstring = "/wp-json/wp/v2/pressrelease?orderby=date&order=desc&_fields=title,date,pressrelease_category,excerpt,content,acf,link"+ (category.length ? "&pressrelease_category=" + reverseCategories[category] : "") + (dateafter.length ? "&after=" + dateafter + "T00:00:00" : "") + (datebefore.length ? "&before=" + datebefore + "T23:59:59" : "") + "&search=" + encodeURIComponent(fulltext);
            fetch(fetchstring + "&per_page=" + numberResultsToReturn[viewType] + "&offset=" + currentNumberItems).then((response) => {
                maxNumberItems = response.headers.get("X-WP-Total");
                return response.json();
            }).then((json) => {
                if(Array.isArray(json)) {
                    currentScope = performance.now();
                    var container = document.createElement("div");
                    container.className = "pressreleases";
                    container.innerHTML = template.render(json);
                    while(resultarea.children.length) {
                        resultarea.lastElementChild.remove();
                    }
                    resultarea.appendChild(container);
                    currentNumberItems += json.length;
                    if(currentNumberItems > maxFetchmoreItems) {
                        maxFetchmoreItems = currentNumberItems;
                    }
                    if(currentNumberItems < maxNumberItems) {
                        fetchmorestringbase = fetchstring;
                        commandArea.style.display = "";
                        if(maxFetchmoreItems > currentNumberItems) {
                            loadmoreCommand.click();
                        }
                    }
                }
            });
        } else if(forceAmount) {
            loadmore();
            forceAmount = false;
        }
    }
    function loadmore() {
        var thisScope = currentScope;
        commandArea.style.display = "none";
        fetch(fetchmorestringbase + "&per_page=" + (forceAmount || numberResultsToReturn[viewType]) + "&offset=" + currentNumberItems).then((response) => {
            return response.json();
        }).then((json) => {
            if(Array.isArray(json) && thisScope === currentScope) {
                var container = document.createElement("div");
                container.className = "pressreleases";
                container.innerHTML = template.render(json);
                resultarea.appendChild(container);
                currentNumberItems += json.length;
                if(currentNumberItems > maxFetchmoreItems) {
                    maxFetchmoreItems = currentNumberItems;
                }
                if(currentNumberItems < maxNumberItems) {
                    commandArea.style.display = "";
                    if(maxFetchmoreItems > currentNumberItems) {
                        loadmoreCommand.click();
                    }
                }
            }
        });
    }
    function loadall() {
        maxFetchmoreItems = maxNumberItems;
        loadmore();
    }
    function changeView() {
        document.querySelector(".js-command.active")?.classList.remove("active");
        this.classList.add("active");
        viewType = viewTypes[this.dataset.command];
        if (viewType !== old.viewType) {
            old.viewType = viewType;
            resultarea.setAttribute("data-view", "" + viewType);
            if(currentNumberItems < numberResultsToReturn[viewType] && currentNumberItems < maxNumberItems) {
                forceAmount = numberResultsToReturn[viewType] - currentNumberItems;
            }
            location.hash = decodeURIComponent(location.hash).split("/")[0] + "/" + this.dataset.command;
        }
    }
    function handleCategory(e) {
        var hashes = decodeURIComponent(location.hash).split("/");
        location.hash = this.getAttribute("href") + (hashes.length > 1 ? "/" + hashes[1] : "");         // this.href includes path
        e.preventDefault();
    }

    // code assignment
    loadmoreCommand.addEventListener("click", loadmore);
    loadallCommand.addEventListener("click", loadall);
    document.querySelectorAll(".presscenter .filterrow input").forEach((i) => {
        i.addEventListener("input", updateResults);
    });
    document.querySelectorAll(".presscenter .filterrow .js-dropdown-item").forEach((d) => {
        d.addEventListener("click", handleCategory);
    });
    addEventListener("hashchange", updateResults);
    document.querySelectorAll(".js-command").forEach((c) => {
        c.addEventListener("click", changeView);
    });

    updateResults();
})();